import { createRouter, createWebHistory } from "vue-router";

import Home from "../views/Home.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: { title: "Healthark | Home" },
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Aboutus.vue"),
    meta: { title: "Healthark | About Us" },
  },
  {
    path: "/products",
    name: "products",
    component: () =>
      import(/* webpackChunkName: "products" */ "../views/Products.vue"),
    meta: { title: "Healthark | Products" },
    redirect: { name: "insurance" },
    children: [
      {
        path: "/products/insurance",
        name: "insurance",
        component: () =>
          import(
            /* webpackChunkName: "insurance" */ "../components/products/Insurance.vue"
          ),
      },
      {
        path: "/products/referral",
        name: "referral",
        component: () =>
          import(
            /* webpackChunkName: "insurance" */ "../components/products/Referral.vue"
          ),
      },
      {
        path: "/products/telemedicine",
        name: "telemedicine",
        component: () =>
          import(
            /* webpackChunkName: "insurance" */ "../components/products/Telemedicine.vue"
          ),
      },
    ],
  },
  {
    path: '/contact',
    name: 'contact',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue'),
    meta: {title: 'Healthark | Contact Us'},
  },
  {
    path: '/faq',
    name: 'faq',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Faq.vue'),
    meta: {title: 'Healthark | FAQ'},
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  // this.$Progress.start()
  next()
})

// router.afterEach((to, from) => {
//   this.$Progress.finish()
// })


export default router;
